import { useState, useCallback } from "react"

import UpgradeToProModal from "../../upgrade_to_pro_modal"

interface Props {
  currentTier: string
  isTrialing: boolean
  newProPlusSubscriptionUrl: string
  proPlusProductId: string
  subscriptionPaymentType: string
}

const BillingSwitchPlanLink = ({
  currentTier,
  isTrialing,
  newProPlusSubscriptionUrl,
  proPlusProductId,
  subscriptionPaymentType,
}: Props) => {
  const [showModal, setShowModal] = useState(false)

  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  }, [showModal])

  const onSwitchLinkClick = (evt:MouseEvent)  => {
    evt.preventDefault()
    toggleModal()
  }

  return (
    <>
      <a
        onClick={onSwitchLinkClick}
        class="link-standalone"
        data-track-ifttt-next-event="click"
        data-track-data={JSON.stringify(
          {object_type: "switch_plan", object_id: "Pro+", location_type: "billing"}
        )}
      >
        Switch to Pro+
      </a>
      {showModal && (
        <UpgradeToProModal
          visible={showModal}
          step="plan_upgrade"
          trackLocationType="billing"
          eligibleForTrial={false}
          onUpgrade={() => (window.location.reload())}
          {...{
            currentTier,
            isTrialing,
            newProPlusSubscriptionUrl,
            proPlusProductId,
            subscriptionPaymentType,
          }}
          onClose={() => toggleModal()}
        />
      )}
    </>
  )
}

export default BillingSwitchPlanLink
